import React, { useEffect, useRef, useState } from "react";
import Icon from "../../YourAIAgents/components/components/icon";
import { useNavigate, useParams } from "react-router-dom";
import ShareChatModal from "./ShareChatModal";
import { useUsersContext } from "../../../context/usersContext";
import RenameChatModal from "./RenameChatModal";
import { useUserInfo } from "../../../context/user";
import axios from "axios";
import env from "../../../config/env";
import DeleteChatModal from "./DeleteChatModal";

const SidebarChatLink = ({ fav = true, item }) => {
  const [showOptions, setShowOptions] = useState(false);
  const dotsRef = useRef();
  const navigate = useNavigate();
  const params = useParams();
  const [userInfo, , , , userActiveLocation] = useUserInfo();
  const { openShareModal, setOpenShareModal, chatError, setChatError } =
    useUsersContext();
  const [openRenameModal, setOpenRenameModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const { fetchChats } = useUsersContext();
  const BASE_URL = `${env.API_URL}/v1`;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dotsRef.current && !dotsRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleFavourite = async (e, chat) => {
    e.stopPropagation();
    e.preventDefault();
    const response = await axios.get(
      `${BASE_URL}/chat/add/favourite?chat_id=${chat?.conversation_id}&user_id=${userInfo?._id}&location_id=${userActiveLocation?.id}`,
    );
    if (response) {
      await fetchChats();
      if (dotsRef.current) {
        setShowOptions(false);
      }
    }
  };

  const removeFromFav = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    const response = await axios.get(
      `${BASE_URL}/chat/remove/favourite?chatId=${item.conversation_id}&user_id=${userInfo?._id}&location_id=${userActiveLocation?.id}`,
    );
    if (response) {
      await fetchChats();
      if (dotsRef.current) {
        setShowOptions(false);
      }
    }
  };

  return (
    <div ref={dotsRef}>
      <div
        onClick={() => {
          navigate(`/app/chat/${item.conversation_id}`);
          chatError?.showError &&
            setChatError({
              showError: false,
              errorMessage: "",
              classNames: "",
              iconColor: "",
            });
        }}
        className="cursor-pointer"
      >
        <div
          className={`flex mx-1.5 px-1.5 py-2 items-center my-1 rounded-[4px] relative ${params.id && params.id === item.conversation_id ? "bg-[#E5E5E5]" : "bg-transparent"}`}
        >
          {fav && (
            <div onClick={(e) => removeFromFav(e)}>
              <Icon id="pintask" />
            </div>
          )}

          <div className="text-nowrap w-full truncate mx-4">{item.name}</div>
          <div
            className="rotate-90 relative p-2 mr-2"
            onClick={(e) => {
              e.stopPropagation();
              setShowOptions(!showOptions);
            }}
          >
            <Icon id="threeDots" />
          </div>
          {showOptions && (
            <div className="absolute right-2.5 top-10 bg-white z-[999]">
              {!fav && (
                <div
                  className="flex items-center gap-3 border-t border-l border-r px-2 text-[12px] py-2"
                  style={{ borderRadius: "4px 4px 0px 0px" }}
                  onClick={(e) => handleFavourite(e, item)}
                >
                  <div className="">
                    <Icon id="pintask" style={{ fontSize: "12px" }} />
                  </div>
                  <p className="">Pin</p>
                </div>
              )}
              <div
                className="flex items-center gap-3 border-t border-l border-r px-2 text-[12px] py-2"
                style={{ borderRadius: !fav ? "0px" : "4px 4px 0px 0px" }}
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenRenameModal(true);
                }}
              >
                <div className="">
                  <Icon id="pencilblack" style={{ fontSize: "12px" }} />
                </div>
                <p className="">Rename</p>
              </div>
              <div
                className="flex items-center gap-3 border-t border-l border-r px-2 text-[12px] py-2"
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenShareModal(item.conversation_id);
                }}
              >
                <div className="">
                  <Icon id="share" style={{ fontSize: "12px" }} />
                </div>
                <p className="">Share</p>
              </div>

              <div
                className="flex items-center gap-3 border-b border-t border-l border-r px-2 text-[12px] py-2"
                style={{ borderRadius: "0px 0px 4px 4px" }}
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenDeleteModal(true);
                }}
              >
                <div className="">
                  <Icon id="delete" style={{ fontSize: "12px" }} />
                </div>
                <p className="">Delete</p>
              </div>
            </div>
          )}
        </div>
      </div>
      <ShareChatModal
        isOpen={openShareModal === item.conversation_id}
        onClose={() => setOpenShareModal(null)}
        chatTitle={item.name}
        contact={item.userId}
        id={item.conversation_id}
      />
      {openRenameModal && (
        <RenameChatModal
          isOpen={openRenameModal}
          onClose={() => setOpenRenameModal(false)}
          chatTitle={item.name}
          id={item.conversation_id}
        />
      )}
      {openDeleteModal && (
        <DeleteChatModal
          isOpen={openDeleteModal}
          onClose={() => setOpenDeleteModal(false)}
          id={item.conversation_id}
          fetchChats={fetchChats}
          navigateBack={item.conversation_id === params?.id}
        />
      )}
    </div>
  );
};

export default SidebarChatLink;
